/** The agent's avatar wherever the chat draws it beside people: its author run, the mention picker and a
 *  mention chip. The name is `t.chat.roleElowen`; the product identity is the same on every instance. */
export const AGENT_AVATAR_SRC = '/chetty-icon-192.png';
